import { AuxButton } from "@blk/aladdin-react-components-es";
import { AuxButtonTypeEnum } from "@blk/aladdin-web-components";
import { isEqual } from "lodash";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { CloseDialogButton } from "./closeButtonDialog";
import { CustomFooter } from "./customFooter";
import { insPortfoliosStateId } from "common/constants";
import { handleDeleteButtonClicked } from "components/pages";
import { Permissions } from "feature-flag";
import { usePermission } from "feature-flag/hooks/usePermission";
import { useDeletePortfolios } from "hooks/use-delete-portfolios";
import { language } from "language/default";
import { closeDialog } from "store/messages-dialog";
export const InsDeletePortfolioDialogAction = () => {
    const dispatch = useDispatch();
    const [queryState, deletePortfoliosMutation] = useDeletePortfolios(), deletePortfolioPermission = usePermission([Permissions.UPDATE_DELETE_PORTFOLIO]);
    const selectedRows = useSelector((state) => state.grids.state[insPortfoliosStateId]?.selectedRows, isEqual) ?? [];
    return React.createElement(CustomFooter, null,
        React.createElement(AuxButton, { label: language.en.common.delete, key: "main-delete-button", isDisabled: queryState.isPending, icon: queryState.isPending ? "loading" : undefined, type: AuxButtonTypeEnum.DESTRUCTIVE_PRIMARY, onClick: () => {
                if (selectedRows?.length) {
                    const deleteRequest = { deletePortfolioRequest: { portfolioIds: selectedRows } };
                    deletePortfoliosMutation(deleteRequest, {})?.then(() => {
                        handleDeleteButtonClicked(deletePortfolioPermission, dispatch);
                        dispatch(closeDialog());
                    });
                }
                else {
                    handleDeleteButtonClicked(deletePortfolioPermission, dispatch);
                }
            } }),
        React.createElement(CloseDialogButton, null));
};
